module.exports = __webpack_public_path__ + "img/7b93d52.jpg";